import React, { useState, useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';

import SUTextField from '../../Components/SUTextField';
import NodeEditorChrome from '../../Components/NodeEditorChrome';
import TriggerTypeField from '../../Components/TriggerTypeField';
import useNodeEditor from '../../Components/useNodeEditor';

import styledComponent from 'styled-components';
import Select from 'react-select';

import { LuFileJson } from 'react-icons/lu';

const JSON_NODE_COLOR = '#A7ADA7';

const Json = ({
  selectedNode,
  handleSelectedNode,
  removeNode,
  nodes,
  edges,
  editFlow,
  updateBot,
  truncateText,
  customStyles,
  customStylesDark,
  isDark,
  watchSelectedNode,
  contextVariables,
  onMouseDown,
  isDragging,
}) => {
  const {
    watch,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    getValues,
  } = useForm({});

  // ------> Selects, Radios, Checkbox
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const { handleInputChange, loadData, saveNode, getIsDirty } = useNodeEditor({
    selectedNode,
    handleSelectedNode,
    nodes,
    edges,
    editFlow,
    updateBot,
    reset,
    getValues,
  });

  // FUNCTIONS

  //# Function para manejar cambios de estados de campos

  //# Function para guardar los datos
  const saveData = (values) => {
    setLoadingUpdate(true);

    const data = {
      title: values.title,
      user_response: values.user_response,
      trigger_type: selectedNode.data?.trigger_type || 'message',
      json: values.json,
    };

    saveNode(data, () => {
      setLoadingUpdate(false);
    });
  };

  //# Function para obtner data
  const getData = () => {
    let objectData = {
      title: selectedNode.data?.title ?? null,
      user_response: selectedNode.data?.user_response ?? null,
      trigger_type: selectedNode.data?.trigger_type ?? 'message',
      json: selectedNode.data?.json ?? null,
    };
    loadData(objectData);
  };

  useEffect(() => {
    getData();
  }, [watchSelectedNode]);

  return (
    <NodeEditorChrome
      icon={LuFileJson}
      color={JSON_NODE_COLOR}
      typeName="JSON"
      title={truncateText(selectedNode.data.title)}
      onRemove={() => removeNode(selectedNode.id)}
      onMouseDown={onMouseDown}
      isDragging={isDragging}
      onClose={() => handleSelectedNode(null)}
      formId="jsonForm"
      saving={loadingUpdate}
      isDark={isDark}
      getIsDirty={getIsDirty}
    >
        <form id="jsonForm" onSubmit={handleSubmit(saveData)} style={{ width: '100%' }}>
          <div>
            <div className="col p-0">
              <SUTextField
                id="title"
                name="title"
                label="Título:"
                type="text"
                selectedNode={selectedNode}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                {...register('title', {
                  required: {
                    value: true,
                    message: 'Campo requerido.',
                  },
                  pattern: {
                    value: /\S+/,
                    message: 'No puede ser solo espacios en blanco',
                  },
                })}
              />
            </div>
            <div className="col p-0 mt-4">
              <TriggerTypeField
                value={selectedNode.data?.trigger_type}
                handleInputChange={handleInputChange}
                isDark={isDark}
                customStyles={customStyles}
                customStylesDark={customStylesDark}
              />
            </div>
            <div className="col p-0 mt-4">
              <SUTextField
                id="user_response"
                name="user_response"
                label="Respuesta del cliente:"
                hint="Lo que debe llegar para activar este nodo: el texto que escribe el cliente, el título de un botón, o * para cualquier respuesta. Para varios, separalos con  /  ."
                type="textArea"
                selectedNode={selectedNode}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                {...register('user_response', {
                  required: {
                    value: true,
                    message: 'Campo requerido.',
                  },
                  pattern: {
                    value: /\S+/,
                    message: 'No puede ser solo espacios en blanco',
                  },
                })}
              />
            </div>
            <div className="col p-0 mt-4">
              <SUTextField
                id="json"
                name="json"
                label="Json:"
                type="text"
                typeVariables={['api']}
                showVariables
                selectedNode={selectedNode}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                contextVariables={contextVariables}
                {...register('json', {
                  required: {
                    value: true,
                    message: 'Campo requerido.',
                  },
                  pattern: {
                    value: /\S+/,
                    message: 'No puede ser solo espacios en blanco',
                  },
                })}
              />
            </div>
          </div>
        </form>
    </NodeEditorChrome>
  );
};

export default Json;
